import React from "react";
import { PROJECTS } from "../constants";
import { ExternalLink, Github, Monitor } from "lucide-react";

const Works: React.FC = () => {
  return (
    <div className="pt-32 pb-20 px-6 md:px-20 max-w-7xl mx-auto">
      <div className="mb-16">
        <h2 className="text-4xl md:text-6xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-500">
          Selected Works
        </h2>
        <p className="text-slate-400 max-w-xl">
          A collection of digital artifacts exploring the intersection of art,
          logic, and high-performance computing.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {PROJECTS.map((project) => (
          <div
            key={project.id}
            className="group relative bg-slate-900/40 border border-slate-800 rounded-2xl p-8 hover:bg-slate-900/60 transition-all hover:border-cyan-900/30 hover:-translate-y-1 flex flex-col justify-between"
          >
            <div>
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-2xl font-semibold group-hover:text-cyan-400 transition-colors">
                  {project.name}
                </h3>
                {project.githubLink ? (
                  <a
                    href={project.githubLink}
                    className="p-2 text-slate-400 hover:text-white transition-colors bg-slate-800/50 rounded-lg"
                    target="_blank"
                    rel="noreferrer"
                    title="View Source on GitHub"
                  >
                    <Github size={18} />
                  </a>
                ) : (
                  <span className="px-3 py-2 text-xs font-medium text-slate-400 bg-slate-800/50 rounded-lg">
                    Private
                  </span>
                )}
              </div>

              <p className="text-slate-400 text-sm leading-relaxed mb-6">
                {project.description}
              </p>

              <div className="flex flex-wrap gap-2 mb-8">
                {project.techStack.map((tech) => (
                  <span
                    key={tech}
                    className="px-3 py-1 text-[10px] uppercase tracking-wider font-bold bg-slate-800/50 text-slate-300 rounded-full border border-slate-700/50"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-auto">
              {project.deploymentLink && (
                <a
                  href={project.deploymentLink}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full py-3 px-6 bg-cyan-500 text-slate-950 font-bold rounded-xl hover:bg-cyan-400 hover:scale-[1.02] transition-all active:scale-95 group/btn"
                >
                  <Monitor
                    size={18}
                    className="transition-transform group-hover/btn:-translate-y-0.5"
                  />
                  Live Demo
                  <ExternalLink size={14} className="opacity-50" />
                </a>
              )}
            </div>

            {/* Subtle glow effect on hover */}
            <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500/10 to-transparent rounded-2xl blur opacity-0 group-hover:opacity-100 transition duration-500 -z-10"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Works;
